import React from 'react';

interface ProgressDotsProps {
  total: number;
  filled: number;
}

export const ProgressDots: React.FC<ProgressDotsProps> = ({ total, filled }) => {
  return (
    <div className="flex gap-1 ml-2">
      {[...Array(total)].map((_, i) => (
        <div
          key={i}
          className={`w-2 h-2 rounded-full transition-colors ${
            i < filled ? 'bg-white' : 'bg-black/20'
          }`}
        />
      ))}
    </div>
  );
};
